import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Alert } from "@grandvisionhq/iris-ui";
import { Modal } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { pushStoreFiltersModalCloseEvent, pushStoreFiltersModalClickEvent } from "../../../../data-layer/data-layer/storeFilters.js";
import StoreFilters from "../../../StoreFilters/components/StoreFilters/StoreFilters.js";
/* empty css                       */
const StoreFiltersModal = ({
  isOpen,
  onModalClose,
  filters,
  appliedFilters,
  hasAppliedFilters,
  toggleFilter,
  resultsCount,
  isLoadingResults,
  clearFilters
}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const labels = {
    cta: getLabel("stores.storeFilters.cta"),
    headerButton: getLabel("stores.storeFilters.modal.clearAll"),
    close: getLabel("stores.storeFilters.modal.close"),
    viewXResults: getFormattedLabel("stores.storeFilters.modal.viewXResults", {
      labelData: {
        count: `${resultsCount}`
      }
    }),
    noResults: getLabel("stores.storeFilters.modal.noResults")
  };
  const showResults = hasAppliedFilters && resultsCount > 0;
  const buttonCaption = showResults ? labels.viewXResults : labels.close;
  const onHandleSubmit = () => {
    if (showResults) {
      pushStoreFiltersModalClickEvent({
        eventName: "store_filters_click",
        interactionType: "filter_stores_view_stores",
        listOfSelectedFilters: Object.keys(appliedFilters).flatMap(
          (key) => appliedFilters[key]?.map((filter) => `${key}:${filter}`) || []
        ),
        availableStores: resultsCount
      });
    } else {
      pushStoreFiltersModalCloseEvent({
        eventName: "store_filters_click",
        interactionType: "store_filters_close",
        closeOption: "go_back_option"
      });
    }
    onModalClose();
  };
  const onHandleBackIconClick = () => {
    pushStoreFiltersModalCloseEvent({
      eventName: "store_filters_click",
      interactionType: "store_filters_close",
      closeOption: "arrow_option"
    });
  };
  const onHandleRandomClick = () => {
    pushStoreFiltersModalCloseEvent({
      eventName: "store_filters_click",
      interactionType: "store_filters_close",
      closeOption: "random_click_option"
    });
  };
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen,
      onModalClose,
      hasBackButton: true,
      additionalEventsWithBackIcon: onHandleBackIconClick,
      additionalEventsWithRandomAreaClick: onHandleRandomClick,
      title: labels.cta,
      headerTextButtonProps: {
        label: labels.headerButton,
        onClick: clearFilters,
        isDisabled: !hasAppliedFilters
      },
      footer: showResults || isLoadingResults || !hasAppliedFilters ? /* @__PURE__ */ React.createElement(
        Button,
        {
          caption: buttonCaption,
          variant: showResults ? "solid" : "outline",
          className: "store-filters-modal__footer-button",
          onClick: onHandleSubmit,
          isLoading: isLoadingResults
        }
      ) : /* @__PURE__ */ React.createElement(Alert, { variant: "warning", className: "alert-m-default store-filters-modal__footer-alert" }, labels.noResults)
    },
    /* @__PURE__ */ React.createElement(
      StoreFilters,
      {
        filters,
        appliedFilters,
        toggleFilter,
        isLoadingResults
      }
    )
  );
};
export {
  StoreFiltersModal as default
};
//# sourceMappingURL=StoreFiltersModal.js.map
